
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"16","height":"17"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M5.796 14.055c.239 0 .438-.08.598-.24L10.595 9.7c.113-.11.195-.22.246-.334a.902.902 0 00.076-.369 1.008 1.008 0 00-.079-.375.996.996 0 00-.243-.328L6.394 4.188a.813.813 0 00-.598-.24.872.872 0 00-.75.421.854.854 0 00.158 1.061l3.68 3.568-3.68 3.563a.89.89 0 00-.275.638.857.857 0 00.867.856z","fill":"#757F8A","fill-rule":"evenodd"}})])
          )
        }
      }
    